
(function () {
  'use strict';

  function initPiEngraving(root) {
    var widgets = [];

    if (
      root.matches &&
      root.matches('[data-pi-engraving]')
    ) {
      widgets.push(root);
    }

    if (root.querySelectorAll) {
      widgets = widgets.concat(
        Array.from(
          root.querySelectorAll('[data-pi-engraving]')
        )
      );
    }

    widgets.forEach(function (widget) {
      if (widget.dataset.piInitialized === 'true') return;

      var modal = widget.querySelector('[data-pi-modal]');
      var input = widget.querySelector('[data-pi-input]');
      var counter = widget.querySelector('[data-pi-counter]');
      var trigger = widget.querySelector('[data-pi-open]');
      var save = widget.querySelector('[data-pi-save]');
      var clearButton = widget.querySelector('[data-pi-clear]');
      var summary = widget.querySelector('[data-pi-summary]');

      if (!modal || !input || !trigger || !save) return;

      widget.dataset.piInitialized = 'true';

      var previousFocus = null;
      var propertyName = 'properties[Custom Engraving]';

      /*
       * UPDATE PROPERTY NAME
       * Blank value: remove name so Shopify does not submit it.
       * Non-blank value: restore name so Shopify submits it.
       */
      function updateEngravingProperty() {
        var value = input.value.trim();

        if (value.length > 0) {
          input.setAttribute('name', propertyName);
        } else {
          input.removeAttribute('name');
        }
      }

      /* OPEN POPUP */
      function openModal() {
        previousFocus = document.activeElement;

        modal.hidden = false;

        document.body.classList.add(
          'pi-custom-engraving-open'
        );

        requestAnimationFrame(function () {
          input.focus();
        });
      }

      /* CLOSE POPUP */
      function closeModal() {
        modal.hidden = true;

        document.body.classList.remove(
          'pi-custom-engraving-open'
        );

        if (
          previousFocus &&
          typeof previousFocus.focus === 'function'
        ) {
          previousFocus.focus();
        }
      }

      /* UPDATE CHARACTER COUNTER */
      function updateCounter() {
        if (counter) {
          counter.textContent = input.value.length;
        }
      }

      /* UPDATE SAVED SUMMARY */
      function updateSummary() {
        var value = input.value.trim();

        if (summary) {
          summary.textContent = value
            ? 'Engraving: ' + value
            : '';
        }

        if (clearButton) {
          clearButton.hidden = !value;
        }

        widget.classList.toggle(
          'has-engraving',
          value.length > 0
        );
      }

      /* OPEN BUTTON */
      trigger.addEventListener('click', function () {
        openModal();
      });

      /* CLOSE BUTTON AND BACKDROP */
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-pi-close]')) {
          closeModal();
        }
      });

      /* INPUT COUNTER AND PROPERTY HANDLING */
      input.addEventListener('input', function () {
        updateCounter();
        updateEngravingProperty();
      });

      /* SAVE ENGRAVING */
      save.addEventListener('click', function () {
        if (!input.checkValidity()) {
          input.reportValidity();
          input.focus();
          return;
        }

        updateEngravingProperty();
        updateSummary();
        closeModal();
      });

      /* CLEAR ENGRAVING */
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          input.value = '';

          updateCounter();
          updateSummary();
          updateEngravingProperty();

          input.dispatchEvent(
            new Event('input', { bubbles: true })
          );

          input.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        });
      }

      /* ESCAPE KEY */
      function handleKeydown(event) {
        if (
          !modal.hidden &&
          event.key === 'Escape'
        ) {
          closeModal();
        }
      }

      document.addEventListener(
        'keydown',
        handleKeydown
      );

      /* INITIAL STATE */
      updateCounter();
      updateSummary();
      updateEngravingProperty();
    });
  }

  /* INITIAL PAGE LOAD */
  function startPiEngraving() {
    initPiEngraving(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPiEngraving
    );
  } else {
    startPiEngraving();
  }

  /* SHOPIFY THEME EDITOR RELOAD */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initPiEngraving(event.target);
    }
  );
})();
